import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ICONS } from '../../../utils/svg-icons';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';

@Component({
  selector: 'app-view-store-popup',
  templateUrl: './view-store-popup.component.html',
  styleUrl: './view-store-popup.component.scss',
  imports: [SafeHtmlPipe],
})
export class ViewStorePopupComponent {
  @Input() public entity: any;
  ICONS = ICONS;
  constructor(
    private _activeModal: NgbActiveModal,
    private _router: Router,
  ) {}

  onClose() {
    this._activeModal.close();
  }
  closeModalAndNavigate(route: string) {
    this.onClose();
    this._router.navigate([route]);
  }
}
